import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconImagine: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconImagine"><Path fillRule="evenodd" clipRule="evenodd" d="M11 2C15.3126 2 18.8255 5.41255 18.9912 9.68457L21.3564 13.2324L19 14.999V17C19 18.1046 18.1046 19 17 19H14V22H6V16.2422C4.17357 14.7774 3 12.5266 3 10C3 5.58172 6.58172 2 11 2ZM9.77539 8.77539L7.5 9.65039V10.3496L9.77539 11.2246L10.6504 13.5H11.3496L12.2246 11.2246L14.5 10.3496V9.65039L12.2246 8.77539L11.3496 6.5H10.6504L9.77539 8.77539Z" fill="currentColor"/></CentralIconBase>;
});

export default IconImagine;
